import React from "react";
import {
	BrowserRouter as Router,
	Routes,
	Route,
} from "react-router-dom";
import Home from "./pages";
import Footer from "./componets/footer";
import Header from "./componets/header";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.kidslearning.kidsguru";

const DownloadRedirect = () => {
	// Execute instant redirect immediately before rendering any DOM
	window.location.replace(PLAY_STORE_URL);
	return null;
};

function App() {
	return (
		<Router>
			<Routes>
				<Route exact path="/" element={<Home />} />
				<Route path="/download" element={<DownloadRedirect />} />
				<Route path="/footer" element={<Footer />} />
				<Route path="/header" element={<Header />} />
			</Routes>
		</Router>
	);
}

export default App;